<template>
  <qtm-dialog-card
    v-bind="$attrs"
    closable
    :model-value="modelValue"
    title="Edit QTY and U/M"
    width="502"
    @update:model-value="$emit('update:model-value', $event)"
  >
    <div>
      For <span class="text-lowercase" v-text="itemType" /> item: {{ item.description }}
    </div>
    <qtm-input-label class="mt-4" label="QTY">
      <qtm-number-field v-model="quantity" hide-details @blur="updateUnitPrice" />
    </qtm-input-label>
    <qtm-input-label class="my-4" label="U/M">
      <qtm-select
        v-if="units.length > 0"
        v-model="unit"
        hide-details
        item-title="description"
        item-value="code"
        :items="units"
      />
      <qtm-text-field v-else v-model.trim="unit" hide-details />
    </qtm-input-label>
    <qtm-input-label label="Unit Price">
      <qtm-number-field v-model="unitPrice" hide-details @blur="updateTotal" />
    </qtm-input-label>
    <template v-slot:actions>
      <qtm-btn block :disabled="disabled" size="x-large" @click="save">
        Save
      </qtm-btn>
    </template>
  </qtm-dialog-card>
</template>

<script setup lang="ts">
import type { LineItem } from '@quotetome/materials-api'
import { UNIT_PRICE_DECIMAL_PLACES } from '@/constants'

export interface Props {
  item: LineItem
  itemType: string
  modelValue?: boolean
  units?: any[]
}

const props = withDefaults(defineProps<Props>(), {
  units: () => []
})
const emit = defineEmits(['update:item', 'update:model-value'])

const quantity = ref(1)
const unit = ref('')
const unitPrice = ref(0)
let total = 0

const disabled = computed(() => !quantity.value || !unit.value || !unitPrice.value)

watch(() => props.modelValue, () => {
  if (props.modelValue) {
    quantity.value = Number(props.item.quantity)
    unit.value = props.item.unit || ''
    unitPrice.value = Number(props.item.unit_price)
    total = Number(quantity.value * unitPrice.value)
  }
}, { immediate: true })

const save = () => {
  emit('update:item', { ...props.item, quantity: quantity.value, unit: unit.value, unit_price: unitPrice.value })
  emit('update:model-value', false)
}

const updateUnitPrice = () => {
  if (total && quantity.value) {
    const value = Number((total / quantity.value).toFixed(UNIT_PRICE_DECIMAL_PLACES))

    if (Number.isFinite(value)) {
      unitPrice.value = value
    }
  }
}

const updateTotal = () => {
  if (quantity.value && unitPrice.value) {
    total = quantity.value * unitPrice.value
  }
}
</script>
